import MyNavbar from '../../components/navbar/MyNavbar'
import './Articles.css'
import { useState, useEffect } from 'react'
import axios from 'axios'
import Footer from '../../components/footer/Footer'
import { Col, Container, Row, Form } from 'react-bootstrap'
import ArticleItem from '../../components/article/ArticleItem'
import Accordion from 'react-bootstrap/Accordion';
import { FaSort } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { BiSolidCategory } from "react-icons/bi";
import Alert from 'react-bootstrap/Alert';


function Articles() {

    const [articles, setArticles] = useState([])
    // we use this hook below for save our id from check radio btn
    // we write earliest id for amount this states below and show first on load in articles page section.
    const [sortType, setSortType] = useState('earliest')
    // we use this hook for search bar input
    const [searchKey, setSearchKey] = useState('')
    useEffect(() => {
        // first radio btn new one :
        if (sortType === 'earliest') {
            // we use this function for get our info for ex : new or old articles
            getArticlesByOrder('desc', 'id')
        }
        // second radio btn old one :
        else if (sortType === 'latest') {
            getArticlesByOrder('asc', 'id')
        }
        // third radio btn long one :
        else if (sortType === 'longest') {
            getArticlesByOrder('desc', 'readingTime')
        }
        // forth radio btn short one :
        else if (sortType === 'shortest') {
            getArticlesByOrder('asc', 'readingTime')
        }
    }, [sortType])

    // sortHandler func

    const sortHandler = (e) => {
        setSortType(e.target.id)
    }

    // getArticlesByOrder func

    const getArticlesByOrder = (order, column) => {
        axios.get(`http://localhost/react/api/articles/?order=${order}&column=${column}`)
            .then(response => setArticles(response.data.data))
    }

    // searchInputHandler func

    const searchInputHandler = (e) => {
        setSearchKey(e.target.value)

    }

    // searchButtonHandler func

    const searchButtonHandler = () => {
        axios.get(`http://localhost/react/api/articles/?search=${searchKey}&column=writter`)
            .then(response => setArticles(response.data.data))
    }


    return (
        <>
            <MyNavbar />

            <Container>
                <div className="searchSection">
                    <h1 className='vidalokaFont'>Articles List</h1>
                    {/* search bar input */}
                    <div className="searchBoxContainer">
                        <button className='searchButton' onClick={searchButtonHandler}>Search :</button>
                        <input className='searchInput' type="text" onChange={searchInputHandler} />
                    </div>
                </div>
                {/* this row below for accordion menu that filtered all articles for ex: reading time or new and old article add to our page */}
                <Row>
                    {/* first col on left , for accordion menu : */}
                    <Col className='col-12 col-lg-3'>
                        <Accordion alwaysOpen className='py-3'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><FaSort size='20px' /><b>Sort the article :</b></Accordion.Header>
                                <Accordion.Body>
                                    <Form>
                                        {/* first radio btn */}
                                        {/* note : we give name property same to all beacuse we want choose one radio button not all of them */}
                                        <Form.Check
                                            type='radio'
                                            id='earliest'
                                            name='sort'
                                            label='The Newest'
                                            onChange={sortHandler}
                                        />
                                        {/* second radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='latest'
                                            name='sort'
                                            label='The Oldest'
                                            onChange={sortHandler}
                                        />
                                        {/* third radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='longest'
                                            name='sort'
                                            label='The Longest'
                                            onChange={sortHandler}
                                        />
                                        {/* forth radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='shortest'
                                            name='sort'
                                            label='The Shortest'
                                            onChange={sortHandler}
                                        />
                                    </Form>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header><MdCategory size='20px' /><b>Categories of articles :</b></Accordion.Header>
                                <Accordion.Body>
                                    <p> <BiSolidCategory size='20px' /> Categories of articles ...</p>

                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>

                    <Col className='col-12 col-lg-9'>
                        <Row className='row-cols-1 row-cols-md-2 row-cols-xl-3 gy-4 py-3'>
                            {/* second col on right , for our articles : */}
                            {articles.map((article) => (
                                <Col key={article.id}>
                                    <ArticleItem {...article} />
                                </Col>
                            ))}
                        </Row>
                        {/* we use this alert for search box that if we write something on search box and we have not on articles show some altert in our page */}
                        {articles.length === 0 &&
                            <Alert className='py-3 gy-4 mt-2' variant='warning'>
                                <p>No article found !!!</p>
                            </Alert>
                        }
                    </Col>
                </Row>


            </Container>
            <Footer />
        </>
    )
}

export default Articles

